import { ReactNode } from "react";

export function ButtonWrapper({ children }: { children: ReactNode }) {
	return (
		<div className="is-flex is-flex-wrap-wrap is-justify-content-end p-1">
			{children}
		</div>
	);
}
